<template>
  <div class="failure-maintenance">
    <div class="form-section">
      <!-- 设备基本信息表单区域 -->
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">设备SN：</p>
          <el-input
            v-model="orderDetail.deviceSn"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">设备属性：</p>
          <el-input
            :value="formatDeviceNature(orderDetail.deviceAttribute)"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">厂家质保期：</p>
          <el-input
            v-model="orderDetail.manufacturerWarrantyPeriod"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>
      <div class="form-row single-column" v-if="orderDetail.deviceNature === 1">
        <div class="form-field">
          <p class="form-field-title">合同质保期：</p>
          <el-input
            v-model="orderDetail.comprehensiveWarrantyPeriod"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">提出人：</p>
          <el-input
            v-model="orderDetail.submitterName"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">提出日期：</p>
          <el-input
            v-model="orderDetail.submitDate"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">故障图片/视频：</p>
          <div class="fault-media-container">
            <div 
              v-if="faultMediaUrls.length > 0"
              class="fault-media-list"
            >
              <div 
                v-for="(url, index) in faultMediaUrls" 
                :key="index"
                class="fault-media-item"
                @click="!isImageFile(url) && openMediaFile(url)"
              >
                <!-- 图片文件显示 -->
                <el-image
                  v-if="isImageFile(url)"
                  :src="url"
                  class="fault-media-preview fault-media-image"
                  :preview-src-list="faultMediaUrls"
                  :initial-index="index"
                  fit="cover"
                  @error="handleImageError($event)"
                  @load="handleImageLoad($event)"
                >
                  <div slot="error" class="image-slot">
                    <img 
                      src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%22100%22 height%3D%22100%22 viewBox%3D%220 0 80 80%22%3E%3Crect width%3D%2280%22 height%3D%2280%22 fill%3D%22%23f0f0f0%22%2F%3E%3Ctext x%3D%2240%22 y%3D%2245%22 font-size%3D%2214%22 fill%3D%22%23999%22 text-anchor%3D%22middle%22%3E图片加载失败%3C%2Ftext%3E%3C%2Fsvg%3E"
                      class="fault-media-preview fault-media-image"
                    />
                  </div>
                </el-image>
                <!-- 视频文件显示 -->
                <div v-else class="fault-media-preview fault-media-video">
                  <img 
                    src="@/assets/imgs/device_file_video.png" 
                    class="fault-media-video-icon"
                  />
                  <span class="fault-media-video-text">视频文件</span>
                </div>
              </div>
            </div>
            <div 
              v-else
              class="fault-media-empty"
            >
              <span>暂无故障图片/视频</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">关联故障机构：</p>
          <el-input
            v-model="orderDetail.associatedInstitutionName"
            disabled
            placeholder="-"
            class="form-field-input"
          />
        </div>
      </div>

      <!-- 故障处理表单区域 -->
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">故障异常标记：</p>
          <el-select
            v-model="faultExceptionId"
            placeholder="请选择故障异常标记"
            class="form-field-select"
          >
            <el-option
              v-for="item in faultExceptionList"
              :key="item.id"
              :label="item.exceptionReason"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">运维异常标记：</p>
          <el-select
            v-model="operationExceptionId"
            placeholder="请选择运维异常标记"
            class="form-field-select"
          >
            <el-option
              v-for="item in operationExceptionList"
              :key="item.id"
              :label="item.exceptionReason"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="form-row single-column">
        <div class="form-field">
          <p class="form-field-title">维修措施：</p>
          <el-select
            v-model="maintenanceMeasureId"
            placeholder="请选择维修措施"
            class="form-field-select"
          >
            <el-option
              v-for="item in maintenanceMeasureList"
              :key="item.id"
              :label="item.exceptionReason"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field full-width">
          <p class="form-field-title">故障处理详情记录：</p>
          <el-input
            v-model="processingDetails"
            type="textarea"
            placeholder="请详细描述故障处理详情"
            class="form-field-textarea"
            :rows="6"
          >
          </el-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field full-width">
          <p class="form-field-title">上传验收图片：</p>
          <div class="upload-images-container">
            <div class="upload-images-list">
              <div 
                v-for="(image, index) in uploadImages" 
                :key="index"
                class="upload-image-item"
              >
                <img :src="image.url" class="upload-image-preview" />
                <div class="upload-image-remove" @click="removeImage(index)">×</div>
              </div>
              <div 
                v-if="uploadImages.length < 5"
                class="upload-image-add"
                @click="triggerFileInput"
              >
                <span class="upload-image-add-icon">+</span>
                <span class="upload-image-add-text">添加图片</span>
              </div>
            </div>
            <input 
              ref="fileInput"
              type="file"
              accept="image/*"
              multiple
              style="display: none"
              @change="onFileSelect"
            />
            <div class="upload-images-tip">最多上传5张图片，每张图片不超过500KB</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Input, Image } from "element-ui";

export default {
  name: "FailureMaintenance",
  
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElImage: Image,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    }
  },

  data: function () {
    return {
      orderDetail: {},
      faultExceptionId: null,
      operationExceptionId: null,
      maintenanceMeasureId: null,
      processingDetails: "",
      faultExceptionList: [],
      operationExceptionList: [],
      maintenanceMeasureList: [],
      uploadImages: [],
      isSubmitting: false,
      faultMediaUrls: [], // 故障图片/视频 URL 数组
    };
  },

  async mounted() {
    await this.loadOrderDetail();
    await this.loadExceptionReasons();
  },

  watch: {
    // 监听 orderDetail.faultImages 变化，更新故障媒体 URL 列表
    'orderDetail.faultImages': function(newVal) {
      this.parseFaultMediaUrls(newVal);
    }
  },

  methods: {
    async loadOrderDetail() {
      try {
        console.log('=== Loading Order Detail ===');
        console.log('deviceData:', this.deviceData);
        
        if (!this.deviceData || !this.deviceData.maintenanceOrderId) {
          console.warn('No device or maintenanceOrderId found');
          return;
        }
        
        console.log('Calling getSleepDeviceMaintenanceOrderLoad with maintenanceOrderId:', this.deviceData.maintenanceOrderId);
        
        const params = { id: this.deviceData.maintenanceOrderId };
        console.log('API params:', params);
        
        const response = await this.$api.getSleepDeviceMaintenanceOrderLoad(params);
        console.log('API response:', response);
        console.log('Response type:', typeof response);
        console.log('Response keys:', response ? Object.keys(response) : 'no response');
        
        if (response) {
          if (response.data) {
            console.log('Using response.data');
            this.orderDetail = response.data;
          } else {
            console.log('Using response directly');
            this.orderDetail = response;
          }
          console.log('Final orderDetail:', this.orderDetail);
          
          // 回显表单数据
          this.setFormDataFromResponse(this.orderDetail);
        } else {
          console.log('No response received');
          this.setFallbackOrderDetail();
        }
      } catch (error) {
        console.error('=== API Error ===');
        console.error('Error:', error);
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);
        
        // 设置备用数据
        this.setFallbackOrderDetail();
      }
    },

    setFallbackOrderDetail() {
      console.log('Setting fallback order detail');
      this.orderDetail = {
        deviceSn: this.deviceData.deviceSn || '-',
        deviceNature: this.deviceData.deviceAttribute || this.deviceData.deviceNature,
        manufacturerWarrantyPeriod: this.deviceData.manufacturerWarrantyPeriod || '-',
        submitterName: '-',
        submitDate: '-',
        associatedInstitutionName: this.deviceData.outboundHospitalName || '-'
      };
      console.log('Fallback orderDetail set:', this.orderDetail);
    },

    setFormDataFromResponse(orderDetail) {
      console.log('Setting form data from response:', orderDetail);
      
      // 回显故障异常标记
      if (orderDetail.faultExceptionId) {
        this.faultExceptionId = orderDetail.faultExceptionId;
      }
      
      // 回显运维异常标记
      if (orderDetail.operationExceptionId) {
        this.operationExceptionId = orderDetail.operationExceptionId;
      }
      
      // 回显维修措施
      if (orderDetail.maintenanceMeasureId) {
        this.maintenanceMeasureId = orderDetail.maintenanceMeasureId;
      }
      
      // 回显故障处理详情记录
      if (orderDetail.processingDetails) {
        this.processingDetails = orderDetail.processingDetails;
      }
      
      // 回显上传的图片
      if (orderDetail.uploadImages) {
        // 如果uploadImages是字符串（逗号分隔的URL），需要转换为数组
        if (typeof orderDetail.uploadImages === 'string' && orderDetail.uploadImages.trim()) {
          const imageUrls = orderDetail.uploadImages.split(',').filter(url => url.trim());
          this.uploadImages = imageUrls.map((url, index) => ({
            url: url.trim(),
            name: `image_${index + 1}`
          }));
        } else if (Array.isArray(orderDetail.uploadImages)) {
          // 如果uploadImages已经是数组
          this.uploadImages = orderDetail.uploadImages;
        }
      }
      
      // 解析故障图片/视频 URL
      this.parseFaultMediaUrls(orderDetail.faultImages);
      
      console.log('Form data set:');
      console.log('faultExceptionId:', this.faultExceptionId);
      console.log('operationExceptionId:', this.operationExceptionId);
      console.log('maintenanceMeasureId:', this.maintenanceMeasureId);
      console.log('processingDetails:', this.processingDetails);
      console.log('uploadImages:', this.uploadImages);
      console.log('faultMediaUrls:', this.faultMediaUrls);
    },

    // 解析故障图片/视频 URL
    parseFaultMediaUrls(faultImages) {
      if (!faultImages || typeof faultImages !== 'string') {
        this.faultMediaUrls = [];
        return;
      }
      
      // 将逗号分隔的字符串转换为 URL 数组
      this.faultMediaUrls = faultImages
        .split(',')
        .map(url => url.trim())
        .filter(url => url.length > 0);
    },

    // 判断是否为图片文件
    isImageFile(url) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const urlLower = url.toLowerCase();
      return imageExtensions.some(ext => urlLower.endsWith(ext));
    },

    // 打开媒体文件（在新页面中）
    openMediaFile(url) {
      window.open(url, '_blank');
    },

    // 处理图片加载错误
    handleImageError(event) {
      // 设置默认占位图
      event.target.src = 'data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2280%22 height%3D%2280%22 viewBox%3D%220 0 80 80%22%3E%3Crect width%3D%2280%22 height%3D%2280%22 fill%3D%22%23f0f0f0%22%2F%3E%3Ctext x%3D%2240%22 y%3D%2245%22 font-size%3D%2214%22 fill%3D%22%23999%22 text-anchor%3D%22middle%22%3E图片加载失败%3C%2Ftext%3E%3C%2Fsvg%3E';
    },

    // 处理图片加载完成
    handleImageLoad(event) {
      // 图片加载成功后的处理（如果需要）
    },

    async loadExceptionReasons() {
      try {
        const productName = this.deviceData.model || "ZG-S01D";
        console.log('Loading exception reasons with productName:', productName);
        
        const [faultResponse, operationResponse, maintenanceResponse] = await Promise.all([
          this.$api.getSleepDeviceExceptionReasonsList({ type: 1, productName }),
          this.$api.getSleepDeviceExceptionReasonsList({ type: 2, productName }),
          this.$api.getSleepDeviceExceptionReasonsList({ type: 3, productName })
        ]);
        
        console.log('Fault response:', faultResponse);
        console.log('Operation response:', operationResponse);
        console.log('Maintenance response:', maintenanceResponse);
        
        // 处理接口响应，如果返回的数据包含在 .data 或 .list 中
        this.faultExceptionList = faultResponse?.data || faultResponse?.list || faultResponse || [];
        this.operationExceptionList = operationResponse?.data || operationResponse?.list || operationResponse || [];
        this.maintenanceMeasureList = maintenanceResponse?.data || maintenanceResponse?.list || maintenanceResponse || [];
        
        console.log('Final lists:');
        console.log('faultExceptionList:', this.faultExceptionList);
        console.log('operationExceptionList:', this.operationExceptionList);
        console.log('maintenanceMeasureList:', this.maintenanceMeasureList);
      } catch (error) {
        console.error('获取异常原因列表失败:', error);
      }
    },

    formatDeviceNature(nature) {
      switch (nature) {
        case 1:
          return "正式进院";
        case 2:
          return "试用";
        default:
          return "-";
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    onFileSelect(event) {
      const files = Array.from(event.target.files);
      const remainingSlots = 5 - this.uploadImages.length;
      const filesToProcess = files.slice(0, remainingSlots);

      filesToProcess.forEach(file => {
        if (!this.isPicture(file.name)) {
          this.$toast.showRed(`文件 ${file.name} 不是图片格式`);
          return;
        }
        if (file.size > 500000) {
          this.$toast.showRed(`文件 ${file.name} 超过500KB限制`);
          return;
        }
        this.uploadImage(file);
      });

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },

    isPicture(fileName) {
      const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const extension = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
      return validExtensions.includes(extension);
    },

    async uploadImage(file) {
      try {
        const fileData = new FormData();
        fileData.set('file', file);
        fileData.set('fileName', file.name);
        
        const imageUrl = await this.$api.uplodFileWithNameRequest(fileData);
        
        this.uploadImages.push({
          url: imageUrl,
          name: file.name
        });
        
        this.$toast.showGreen(`图片 ${file.name} 上传成功`);
      } catch (error) {
        console.error('图片上传失败:', error);
        this.$toast.showRed(`图片 ${file.name} 上传失败`);
      }
    },

    removeImage(index) {
      this.uploadImages.splice(index, 1);
    },

    async onSubmit() {
      // 避免重复提交
      if (this.isSubmitting) {
        return;
      }
      
      // 验证必填字段
      if (!this.processingDetails.trim()) {
        this.$toast.showRed("请填写故障处理详情记录");
        return;
      }

      this.isSubmitting = true;
      try {
        const params = {
          id: this.deviceData.maintenanceOrderId,
          faultExceptionId: this.faultExceptionId,
          operationExceptionId: this.operationExceptionId,
          maintenanceMeasureId: this.maintenanceMeasureId,
          processingDetails: this.processingDetails,
          uploadImages: this.uploadImages.map(img => img.url).join(','), // 提交图片URL字符串，用逗号分隔
        };

        // 只触发事件，让父组件处理API调用
        this.$emit("onSubmit", params);
      } catch (error) {
        console.error('参数构建失败:', error);
        this.$toast.showRed("参数构建失败");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.failure-maintenance {
  width: 100%;

  .form-section {
    padding: rem(10) 0;
  }


  .required {
    color: #ff4d4f;
  }

  .form-row {
    display: flex;
    gap: rem(20);
    margin-bottom: rem(16);

    &.single-column {
      flex-direction: column;
      gap: 0;
    }
  }

  .form-row .form-field {
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: rem(12);

      &.full-width {
        flex: none;
        width: 100%;
      }


      &-title {
        font-weight: 500;
        margin: 0;
        font-size: rem(14);
        color: #333;
        flex-shrink: 0;
        width: rem(130);
        text-align: left;
      }

      &-display {
        padding: rem(8) rem(12);
        background-color: #f5f5f5;
        border: 1px solid #d9d9d9;
        border-radius: rem(4);
        font-size: rem(14);
        color: #666;
        min-height: rem(32);
        display: flex;
        align-items: center;
        box-sizing: border-box;
      }

      &-input {
        flex: 1;
        
        ::v-deep .el-input__inner {
          height: rem(32);
        }
      }

      &-select {
        flex: 1;
        
        ::v-deep .el-input {
          height: rem(32);
        }
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(120);
          font-family: inherit;
          resize: vertical;
        }
      }
    }
  }

  .upload-images-container {
    flex: 1;
    
    .upload-images-list {
      display: flex;
      flex-wrap: wrap;
      gap: rem(12);
      margin-bottom: rem(8);
    }

    .upload-image-item {
      position: relative;
      width: rem(80);
      height: rem(80);
      border: 1px solid #d9d9d9;
      border-radius: rem(4);
      overflow: hidden;

      .upload-image-preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .upload-image-remove {
        position: absolute;
        top: rem(-5);
        right: rem(-5);
        width: rem(20);
        height: rem(20);
        background-color: #ff4d4f;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: rem(14);
        cursor: pointer;
        font-weight: bold;

        &:hover {
          background-color: #ff7875;
        }
      }
    }

    .upload-image-add {
      width: rem(80);
      height: rem(80);
      border: 2px dashed #d9d9d9;
      border-radius: rem(4);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #666;
      transition: all 0.3s;

      &:hover {
        border-color: #325FAC;
        color: #325FAC;
      }

      .upload-image-add-icon {
        font-size: rem(24);
        margin-bottom: rem(4);
      }

      .upload-image-add-text {
        font-size: rem(12);
      }
    }

    .upload-images-tip {
      font-size: rem(12);
      color: #999;
    }
  }

  /* 故障图片/视频展示栏样式 */
  .fault-media-container {
    flex: 1;
    min-width: 0;
    
    .fault-media-list {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(rem(100), 1fr));
      gap: rem(12);
      margin-bottom: rem(8);
      max-width: 100%;
    }

    .fault-media-item {
      position: relative;
      width: 100%;
      aspect-ratio: 1 / 1;
      border: 1px solid #d9d9d9;
      border-radius: rem(4);
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      box-sizing: border-box;
      
      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
      }
    }

    .fault-media-preview {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* 图片预览样式 */
    .fault-media-image {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: opacity 0.3s ease;
    }

    /* 视频预览样式 */
    .fault-media-video {
      background-color: #f5f5f5;
      flex-direction: column;
      text-align: center;
      justify-content: center;
    }

    .fault-media-video-icon {
      width: rem(32);
      height: rem(32);
      margin-bottom: rem(4);
    }

    .fault-media-video-text {
      font-size: rem(12);
      color: #666;
    }

    /* 空状态样式 */
    .fault-media-empty {
      width: 100%;
      padding: rem(20) 0;
      background-color: #f9f9f9;
      border: 1px dashed #d9d9d9;
      border-radius: rem(4);
      text-align: center;
      color: #999;
      font-size: rem(14);
    }
  }

  /* 响应式样式 */
  @media (max-width: 768px) {
    .fault-media-container {
      .fault-media-list {
        grid-template-columns: repeat(auto-fill, minmax(rem(80), 1fr));
        gap: rem(8);
      }
    }
  }

  @media (max-width: 480px) {
    .fault-media-container {
      .fault-media-list {
        grid-template-columns: repeat(auto-fill, minmax(rem(60), 1fr));
        gap: rem(6);
      }
    }
  }

</style>